import css from "./popUp.module.css";

export default function MainPopForH() {
  return (
    <div className={css.mainPopWrap}>
      <p className={css.mainPopP}>
        Ми називаємося "Час майстрів", бо впевнені: стрімкий розвиток
        технологій, зокрема робототехніки, незабаром приведе до того, що
        основною сферою діяльності людини стане творчість. Та щоб створити щось
        дійсно вартісне, треба бути майстром своєї справи. Наша місія —
        допомогати дітям зростати до рівня майстра."
      </p>
    </div>
  );
}
